/* Arreglo con la lista de unidades */
export const UNIT_LIST = [
    { unitName: 'Pulgadas', unitID: 1 },
    { unitName: 'Milímetros', unitID: 2 }
];


/* Arreglo con la lista de materiales de broca */
export const DRILL_LIST = [
    { name: 'HSS', id: 1 },
    { name: 'Carburo', id: 2 }
];


/* Arreglo con la lista de materiales de machuelo */
export const TAP_LIST = [
    { name: 'HSS', id: 1 }
]


/* Arreglo de estados */
export const STATE_LIST = [
    { name: 'Aguascalientes', id: 1 },
    { name: 'Baja California', id: 2 },
    { name: 'Baja California Sur', id: 3 },
    { name: 'Campeche', id: 4 },
    { name: 'Coahuila de Zaragoza', id: 5 },
    { name: 'Colima', id: 6 },
    { name: 'Chiapas', id: 7 },
    { name: 'Chihuahua', id: 8 },
    { name: 'Ciudad de México', id: 9 },
    { name: 'Durango', id: 10 },
    { name: 'Estado de México', id: 32 },
    { name: 'Guanajuato', id: 11 },
    { name: 'Guerrero', id: 12 },
    { name: 'Hidalgo', id: 13 },
    { name: 'Jalisco', id: 14 },
    { name: 'Michoacán de Ocampo', id: 15 },
    { name: 'Morelos', id: 16 },
    { name: 'Nayarit', id: 17 },
    { name: 'Nuevo León', id: 18 },
    { name: 'Oaxaca', id: 19 },
    { name: 'Puebla', id: 20 },
    { name: 'Querétaro', id: 21 },
    { name: 'Quintana Roo', id: 22 },
    { name: 'San Luis Potosí', id: 23 },
    { name: 'Sinaloa', id: 24 },
    { name: 'Sonora', id: 25 },
    { name: 'Tabasco', id: 26 },
    { name: 'Tamaulipas', id: 27 },
    { name: 'Tlaxcala', id: 28 },
    { name: 'Veracruz', id: 29 },
    { name: 'Yucatán', id: 30 },
    { name: 'Zacatecas', id: 31 },
]

/*  Constantes para ángulos */
export const DEGREES = 180 / Math.PI;
export const RADIANS = Math.PI / 180;
export const PI = 3.1416;